import React, { Component } from 'react';
import classNames from 'classnames';
import ToolbarButton from './ToolbarButton.js';
import DropdownArrowIcon from '../Icons/DropdownArrowIcon.js';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';
import { mergeStyles } from 'wix-rich-content-common';
import 'prop-types';
import 'wix-rich-content-common/libs/Tooltip';

var css_248z = "._40BaN,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.Bp67w{display:flex;width:max-content}[dir] .Bp67w{padding:10px 0}[dir=ltr] .Bp67w{margin-right:10px}[dir=rtl] .Bp67w{margin-left:10px}[dir=ltr] .Bp67w:last-child{margin-right:0}[dir=rtl] .Bp67w:last-child{margin-left:0}[dir] .Bp67w:hover>button{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}@media only screen and (max-width:640px){[dir] [data-query=media] .Bp67w:hover>button{background-color:transparent}}@supports not (contain:inline-size){@media only screen and (max-width:640px){[dir] [data-query=container] .Bp67w:hover>button{background-color:transparent}}}@container (width < 640px){[dir] [data-query=container] .Bp67w:hover>button{background-color:transparent}}[dir] .Bp67w._5JA89 button{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-action-color-fallback-tuple,2,97,255)),.1)}.HGDd4{color:var(--ricos-settings-text-color,#333);font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);line-height:normal}[dir] .HGDd4{background:transparent;border:0;border-radius:var(--ricos-settings-small-buttons-border-radius,unset);cursor:pointer;padding:5px}.HGDd4:disabled{opacity:.4}[dir] .HGDd4:disabled{cursor:default}.HGDd4 ._5JA89{color:var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#0261ff))}.HGDd4 ._5JA89 svg{fill:var(--ricos-settings-action-color,currentColor);color:var(--ricos-settings-action-color,currentColor)}._0u8vm{height:20px;vertical-align:middle;width:20px}._0u8vm svg{fill:var(--ricos-settings-icons-color,currentColor);color:var(--ricos-settings-icons-color,currentColor);height:100%;width:100%}.hytaQ{align-items:center;color:var(--ricos-settings-text-color,#333);display:flex;font-family:var(--ricos-settings-text-font-family,HelveticaNeue,Helvetica,Arial);font-size:14px;font-weight:500;width:max-content!important}[dir=ltr] .hytaQ{margin:0 0 0 5px!important}[dir=rtl] .hytaQ{margin:0 5px 0 0!important}.hC-nH,.xyRTh{align-items:center;display:flex;justify-content:center}[dir=ltr] .hC-nH,[dir=ltr] .xyRTh{margin-left:8px}[dir=rtl] .hC-nH,[dir=rtl] .xyRTh{margin-right:8px}.hC-nH svg,.xyRTh svg{height:16px;width:16px}[dir=ltr] .hC-nH{transform:rotate(180deg)}[dir=rtl] .hC-nH{transform:rotate(-180deg)}";
var Styles = {"fontElementMap":"_40BaN","inlineToolbarButton_wrapper":"Bp67w","inlineToolbarButton_active":"_5JA89","inlineToolbarButton":"HGDd4","inlineToolbarButton_icon":"_0u8vm","inlineToolbarButton_menuButton":"hytaQ","inlineToolbarDropdownButton_arrowIcon":"xyRTh","inlineToolbarDropdownButton_arrowIcon_isOpen":"hC-nH"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
class InlineToolbarButton extends Component {
  constructor(props) {
    super(props);
    this.preventDefault = (event) => event.preventDefault();
    this.onClick = (e) => {
      var _a;
      const { onClick, helpers, pluginType, dataHook, formattingButtonName, isActive, children } = this.props;
      (_a = helpers == null ? void 0 : helpers.onToolbarButtonClick) == null ? void 0 : _a.call(helpers, {
        buttonName: formattingButtonName || dataHook || "",
        pluginId: pluginType,
        value: children ? void 0 : String(!isActive)
      });
      onClick == null ? void 0 : onClick(e);
    };
    const { buttonStyles = {} } = props.theme || {};
    const styles = mergeStyles({ styles: Styles, theme: props.theme });
    this.styles = {
      button: classNames(
        styles.inlineToolbarButton,
        buttonStyles.inlineToolbarButton,
        buttonStyles.pluginToolbarButton
      ),
      buttonWrapper: classNames(
        styles.inlineToolbarButton_wrapper,
        buttonStyles.inlineToolbarButton_wrapper,
        buttonStyles.pluginToolbarButton_wrapper
      ),
      icon: classNames(
        styles.inlineToolbarButton_icon,
        buttonStyles.inlineToolbarButton_icon,
        buttonStyles.pluginToolbarButton_icon
      ),
      active: classNames(
        styles.inlineToolbarButton_active,
        buttonStyles.inlineToolbarButton_active,
        buttonStyles.pluginToolbarButton_active
      ),
      menuButton: classNames(
        styles.inlineToolbarButton_menuButton,
        styles.inlineToolbarButton_icon,
        buttonStyles.inlineToolbarButton_icon,
        buttonStyles.inlineToolbarButton_menuButton,
        buttonStyles.pluginToolbarButton_icon
      ),
      arrowIcon: classNames(
        styles.inlineToolbarButton_icon,
        styles.inlineToolbarDropdownButton_arrowIcon,
        buttonStyles.inlineToolbarButton_icon,
        buttonStyles.pluginToolbarButton_icon
      ),
      arrowIconOpen: styles.inlineToolbarDropdownButton_arrowIcon_isOpen
    };
  }
  render() {
    const {
      isActive,
      tooltipText,
      dataHook,
      tabIndex,
      icon: Icon,
      forwardRef,
      disabled,
      buttonContent,
      showArrowIcon
    } = this.props;
    const { styles } = this;
    const arrowIcon = /* @__PURE__ */ React.createElement(
      "span",
      {
        className: classNames(styles.arrowIcon, {
          [styles.arrowIconOpen]: isActive,
          [styles.active]: isActive
        })
      },
      /* @__PURE__ */ React.createElement(DropdownArrowIcon, null)
    );
    const iconClassNames = classNames(styles.icon, {
      [styles.active]: isActive
    });
    const buttonTextContent = buttonContent || /* @__PURE__ */ React.createElement("div", { className: iconClassNames }, Icon && /* @__PURE__ */ React.createElement(Icon, null));
    const menuButtonClassNames = classNames(styles.menuButton, {
      [styles.active]: isActive
    });
    const wrapperClassNames = classNames(styles.buttonWrapper, { [styles.active]: isActive });
    const isMenu = !!showArrowIcon;
    const codeBlockButton = (
      /* eslint-disable jsx-a11y/no-static-element-interactions */
      /* @__PURE__ */ React.createElement("div", { className: wrapperClassNames }, /* @__PURE__ */ React.createElement(
        "button",
        {
          disabled,
          tabIndex,
          "aria-label": tooltipText,
          "aria-pressed": isActive,
          "data-hook": dataHook,
          onClick: this.onClick,
          className: styles.button,
          ref: forwardRef,
          onMouseDown: this.preventDefault
        },
        isMenu ? /* @__PURE__ */ React.createElement("div", { className: menuButtonClassNames }, buttonTextContent, arrowIcon) : buttonTextContent
      ), this.props.children)
    );
    return /* @__PURE__ */ React.createElement(ToolbarButton, { tooltipText, button: codeBlockButton });
  }
}
var InlineToolbarButton$1 = React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(InlineToolbarButton, __spreadValues({ forwardRef: ref }, props)));

export { InlineToolbarButton$1 as default };
//# sourceMappingURL=InlineToolbarButton.js.map
